import { Alert, Spin, Tag } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ApiError } from "../api/client";
import { useEvidence } from "../api/evidence";
import { PageHead } from "../components/dashboard/Kpi";
import { Crumbs } from "../components/Crumbs";
import { EvidenceDetail } from "../components/evidence/EvidenceDrawer";

/** Pagina dell'evidenza (/evidence/:id): link da incollare in una mail o in Teams, breadcrumb fino al fornitore. */
export default function EvidencePage() {
  const { t } = useTranslation();
  const { id = "" } = useParams();
  const nav = useNavigate();
  const q = useEvidence(id);
  if (q.isLoading) return <Spin style={{ display: "block", margin: 48 }} />;
  if (q.error || !q.data) return <Alert type="error" showIcon message={q.error instanceof ApiError ? q.error.message : t("noResults")} />;
  const e = q.data;
  return (
    <div>
      <Crumbs
        items={[
          { label: t("suppliers"), to: "/suppliers" },
          { label: e.supplierName, to: `/suppliers/${e.supplierId}` },
          ...(e.audit
            ? [
                { label: `${t("f_factory")} ${e.audit.factoryName}`, to: `/factories/${e.audit.factoryId}?s=${e.supplierId}` },
                { label: e.audit.code, to: `/audits/${e.audit.id}` },
                { label: t("evidence"), to: `/audits/${e.audit.id}?tab=ev` },
              ]
            : [{ label: t("evidence"), to: `/suppliers/${e.supplierId}?tab=ev` }]),
          { label: e.name },
        ]}
      />
      <PageHead title={<span style={{ overflowWrap: "anywhere" }}>{e.name}</span>} actions={e.audit?.historical ? <Tag color="purple">{t("f_historical")}</Tag> : null} />
      <EvidenceDetail evidence={e} mode="page" onClose={() => nav(-1)} onChanged={() => void q.refetch()} />
    </div>
  );
}
